import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { EventService } from '../../services/event.service';

@Component({
  selector: 'app-how-to-buy',
  templateUrl: './how-to-buy.component.html',
  styleUrl: './how-to-buy.component.scss',
})
export class HowToBuyComponent implements AfterViewInit {
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  isMobile: boolean = false;
  windowSize: number = 0;
 currentLanguage = '';
  @HostListener('window:resize', ['$event'])
  
  onResize(event: any) {
    if (isPlatformBrowser(this._platformId)) {
      this.windowSize = window.innerWidth;
      this.isMobile = this.windowSize <= 1024 ? true : false;
    }
  }
  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
      private translate: TranslateService,
       private eventService: EventService,
  )
     {
     this.currentLanguage = this.translate.currentLang;
    this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.currentLanguage = params.lang;
    });
  }

  items = [
    {
      title: 'how_to_buy.step_1',
      desc: 'how_to_buy.step_1_desc',
    },
    {
      title: 'how_to_buy.step_2',
      desc: 'how_to_buy.step_2_desc',
    },
    {
      title: 'how_to_buy.step_3',
      desc: 'how_to_buy.step_3_desc',
    },
    {
      title: 'how_to_buy.step_4',
      desc: 'how_to_buy.step_4_desc',
    },
  ];

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.windowSize = window.innerWidth;
      this.isMobile = this.windowSize <= 1024 ? true : false;
      setTimeout(() => {
        if (this.videoPlayer && this.videoPlayer.nativeElement) {
          setTimeout(() => {
            this.videoPlayer.nativeElement.muted = true;
            this.videoPlayer.nativeElement.play();
          }, 1000);
        }
      }, 1000);
    }
  }

 
  navigateToPage(section: string): void {
   this.eventService.redirectTosection(section);
  }
}
